import { render, staticRenderFns } from "./ChatMessageModalDelete.vue?vue&type=template&id=106f937c"
import script from "./ChatMessageModalDelete.vue?vue&type=script&lang=js"
export * from "./ChatMessageModalDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports